import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";

export const uploadResume = createAsyncThunk<string, { resume: File }, { extra: Partial<Dependencies> }>(
  "fundingRequests/uploadResume",
  async ({ resume }: { resume: File }, { extra: { sharedRepository } }) => {
    return sharedRepository!.uploadDocument(resume);
  },
);

export const resetUploadResume = createAction("fundingRequests/resetUploadResume");
